let ip = window.location.hostname;

module.exports = {
  BASE_URL: 'http://' + ip + ':3000'
};
